<template>
  <div id="app" class="full-height" @click="setTimerData">
    <b-overlay fixed no-wrap class="full-height" spinner-variant="primary" :show="isLoading" :variant="variant"
      :opacity="opacity" :blur="blur" z-index="1500" rounded="sm">
    </b-overlay>
    <NavBar :key="navbarComponentKey" v-if="isAuthenticated && !isRouteSelectOrganisation" @kioskMode="kioskMode()" />
    <KioskMode ref="kioskmode" :uuid="uuid" :cliniciansdata="cliniciansdata" :key="uuid + '' + enableKioskMode" />
    <b-container fluid>
      <router-view :key="$route.fullPath" />
    </b-container>
    <b-modal id="errorModal" @hidden="closeModal" v-model="timeouterror.isOpen" v-bind="$attrs"
      :title="timeouterror.title" ok-title="Close" ok-only>
      {{ timeouterror.message }}
    </b-modal>
  </div>
</template>

<script>
import {
  RESET_STATE,
  FETCH_KIOSK_MODE_DATA,
  FETCH_CLINICIAN_DATA,
  RESET_AUTH_STATE,
  FETCH_AVAILABLE_ORGANISATION,
  FETCH_LOGIN_USER_DETAILS
} from "@/store/actions.type";
import { mapGetters } from "vuex";
import config from "@/config.js";
import {
  SET_TIMEOUT_ERROR,
  SET_IS_LOADING,
  SET_KIOSK_MODE_STATUS,
  SET_AUTH,
} from "@/store/mutations.type";
import { checkTimeout } from "@/utils/authUtils.js";
import AuthService from "@/common/auth.service";
import ApiService from "@/common/api.service";
import { Hub } from "aws-amplify";
import eventBus from "@/eventbus.js"

export default {
  name: "App",
  components: {
    NavBar: () => import("@/components/NavBar/NavBar"),
    KioskMode: () => import("@/views/KioskMode/KioskMode"),
  },
  data: function () {
    return {
      timer: config.TIMEOUT,
      roles: [],
      token: null,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      uuid: null,
      cliniciansdata: [],
      navbarComponentKey: 0
    };
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "isLoading",
      "timeouterror",
      "agreementdata",
      "getAvailableOrganisation",
      "enableKioskMode"
    ]),
    isRouteSelectOrganisation() {
      return this.$route.name === 'selectOrganisation'
    }
  },
  mounted() {

    Hub.listen("auth", ({ payload: { event, data } }) => {
      if (event == 'signIn') {
        this.$store.commit(SET_KIOSK_MODE_STATUS, false);
        let response = {
          roles:
            data.signInUserSession.accessToken.payload[
            "cognito:groups"
            ],
          response: data,
        };
        localStorage.setItem(config.TIMER, Date.now());
        localStorage.removeItem("organisationId");
        localStorage.removeItem("fhirOrgFeatures");
        localStorage.removeItem("FhirAuthIdToken");
        this.$store.commit(SET_AUTH, response);
        this.$store.dispatch(FETCH_AVAILABLE_ORGANISATION).then(() => {
          if (this.getAvailableOrganisation.length === 1 && this.getAvailableOrganisation[0].currentUserRoles.length == 1) {
            const org = this.getAvailableOrganisation[0];
            ApiService.setOrganisationId(org.id)
            localStorage.setItem("organisationId", org.id)
            localStorage.setItem("organisationName", org.name);
            localStorage.setItem("organisationFeatures", JSON.stringify(org.features));
            localStorage.setItem("role", org.currentUserRoles[0]);
            this.forceRerender();
            this.$store.dispatch(FETCH_LOGIN_USER_DETAILS).then(() => {
              this.$router.push("/home")
            });
          } else {
            this.$router.push("/home");
          }
        });
      }

    });
  },
  created() {
    localStorage.setItem(config.TIMER, Date.now());
    setInterval(() => {
      if (checkTimeout() && this.isAuthenticated) {
        eventBus.$emit('cancel-timer-event');
        setTimeout(() => {this.logOut()}, 1000);
      }
    }, 5000);
  },
  methods: {
    forceRerender() {
      this.navbarComponentKey += 1;
    },
    setTimerData() {
      if (this.isAuthenticated) {
        localStorage.setItem(config.TIMER, Date.now());
      } else if (checkTimeout() && this.isAuthenticated) {
        this.logOut();
      }
    },
    async kioskMode() {
      await this.$store.commit(SET_IS_LOADING, true);
      Promise.all([
        await this.$store.dispatch(FETCH_KIOSK_MODE_DATA, {
          slug: "onboard",
          params: {},
        }),
        await this.$store.dispatch(FETCH_CLINICIAN_DATA, ""),
      ]).then(async (resp) => {
        if (resp[0].status == 200) {
          AuthService.signOut();
          this.$store.commit(SET_KIOSK_MODE_STATUS, true)
          this.$store.commit(SET_IS_LOADING, false)
          this.$store.dispatch(RESET_AUTH_STATE)
          this.uuid = resp[0].data.code;
          this.cliniciansdata = resp[1]
          this.$refs.kioskmode.show();
          localStorage.clear()
          sessionStorage.clear()
          this.$store.dispatch(RESET_STATE)
          this.$router.push("/kiosk-mode");
        }
      });
    },
    async logOut() {
      Promise.all([
        await this.$store.dispatch(RESET_STATE),
        await this.$store.dispatch(RESET_AUTH_STATE),
      ]).finally(() => {
        localStorage.clear();
        this.$router.push("/login");
        ApiService.removeOrganisationId();
      });
    },
    closeModal() {
      this.$store.commit(SET_TIMEOUT_ERROR, {
        title: null,
        message: null,
        isOpen: false,
      });
    },
  },
};
</script>
<style lang="scss">
html,
body {
  height: 100% !important;
}

.full-height {
  min-height: 100% !important;
}

#app {
  background-color: #f8f8f8;
}

.cellphone {
  border-radius: 4px !important;
}

.flexColumn {
  flex-basis: 25%;
}

.multiselect__placeholder {
  font-size: medium !important;
  color: #6e747a !important;
  display: inline-block;
  margin: 0px !important;
  padding: 0px !important;
}
</style>
